
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface PurchaseRestrictedBannerProps {
  message?: string;
}

export function PurchaseRestrictedBanner({ message = "Your account has been restricted from making purchases." }: PurchaseRestrictedBannerProps) {
  return (
    <div className="bg-red-900/20 border border-red-500/30 rounded-lg p-4 my-4">
      <div className="flex items-center space-x-3">
        <AlertTriangle className="text-red-500 h-6 w-6 flex-shrink-0" />
        <div className="flex-1">
          <h3 className="font-semibold text-red-500">Purchase Restricted</h3>
          <p className="text-gray-300 text-sm mt-1">{message}</p>
        </div>
      </div>
      <div className="mt-3 flex flex-col sm:flex-row gap-3">
        <Button asChild variant="outline" size="sm">
          <Link to="/support">Contact Support</Link>
        </Button>
      </div>
    </div>
  );
}
